const IconCertificate = ({ width = 20, height = 20, fill = "#252525" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V5.25L11.25 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V5.25"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 1.5V4.5C10.5 4.89782 10.658 5.27936 10.9393 5.56066C11.2206 5.84196 11.6022 6 12 6H15"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.75 12.75C4.04547 12.75 4.33806 12.6918 4.61104 12.5787C4.88402 12.4657 5.13206 12.2999 5.34099 12.091C5.54992 11.8821 5.71566 11.634 5.82873 11.361C5.9418 11.0881 6 10.7955 6 10.5C6 10.2045 5.9418 9.91194 5.82873 9.63896C5.71566 9.36598 5.54992 9.11794 5.34099 8.90901C5.13206 8.70008 4.88402 8.53434 4.61104 8.42127C4.33806 8.3082 4.04547 8.25 3.75 8.25C3.15326 8.25 2.58097 8.48705 2.15901 8.90901C1.73705 9.33097 1.5 9.90326 1.5 10.5C1.5 11.0967 1.73705 11.669 2.15901 12.091C2.58097 12.5129 3.15326 12.75 3.75 12.75Z"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 12.375L6 16.5L3.75 15.75L1.5 16.5L2.25 12.375"
        stroke={fill}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default IconCertificate;
